module.exports = "<div class=\"home-container\">\n  <mat-card class=\"card-container\">\n    <div class=\"title\">Urmeo</div>\n    <img src=\"../../assets/logogrey.png\" width=\"150px\" height=\"150px\">\n  </mat-card>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main